import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from '@/pages/home/components/Hero';
import HotList from '@/pages/home/components/HotList';
import Celebrity from '@/pages/home/components/Celebrity';
import Influencer from '@/pages/home/components/Influencer';
import Timeline from '@/pages/home/components/Timeline';
import Featured from '@/pages/home/components/Featured';
import Channels from '@/pages/home/components/Channels';
import Faq from '@/pages/home/components/Faq';
import Newsletter from '@/pages/home/components/Newsletter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <HotList />
        <Celebrity />
        <Influencer />
        <Timeline />
        <Featured />
        <Channels />
        <Faq />
        <Newsletter />
      </main>
      <SiteFooter />
    </div>
  );
}